import React from 'react';

const Empty = () => {
  return (
    <div className="canvas--empty text-center p-4">
      <h5>Add a question to the library!</h5>
      <p>Drag a question type from the left panel.</p>
    </div>
  )
};

export default Empty;